import { useEffect, useState, useRef } from 'react'
import axios from 'axios'
import NavbarTopAdmin from './components/navbarTopAdmin'
import NavbarBottomAdmin from './components/navbarBottomAdmin'
import AuthProvider from '../Authentication/authProvider'

function CercaEventi() {
    const [cercaEventi, setCercaEventi] = useState([])
    const [cercaCittà, setCercaCittà] = useState([])
    const [numCar, setNumCar] = useState({ luogo: '', tipo: '' })
    const [msg, setMsg] = useState({ errorCerca: false })
    const [titolo, setTitolo] = useState('EVENTI CERCATI DAGLI UTENTI')

    const divTipoEvento = useRef()
    const divLuogoEvento = useRef()

    function cittàCercate() {
        divTipoEvento.current.style.display = "none"
        divLuogoEvento.current.style.display = "block"
        setTitolo('CITTA CERCATE DAGLI UTENTI')
    }

    function pulisci() {
        try {
            axios.get('/pulisciCercaEventi')
        } catch (err) { console.log(err) }
        setCercaEventi([]); setCercaCittà([])
    }

    useEffect(() => {
        try {
            axios.get('/getCercaEventi').then(res => {
                setCercaEventi(res.data[0].tipoEvento.split(','))
                setCercaCittà(res.data[0].luogoEvento.split(','))
                console.log(res.data[0].luogoEvento.length)
                setNumCar({ ...numCar, luogo: res.data[0].luogoEvento.length, tipo: res.data[0].tipoEvento.length })
                if (res.data[0].tipoEvento.length > 1800) {
                    setMsg({ ...msg, errorCerca: 'Stai oltrepassando il limite massimo di caratteri in MYSQL tipoEvento' })
                }
                if (res.data[0].luogoEvento.length > 1800) {
                    setMsg({ ...msg, errorCerca: 'Stai oltrepassando il limite massimo di caratteri in MYSQL luogoEvento' })
                }
            })
        } catch (err) { console.log(err) }
    }, [])

    // useEffect(() => { console.log(cercaEventi) }, [cercaEventi])
    return (<>
        <NavbarTopAdmin />
        <NavbarBottomAdmin />
        <AuthProvider />
        <div className='homePadding'>
            <h5 style={{ marginTop: '3rem' }}><b>{titolo}</b></h5>

            {msg.errorCerca &&
                <h5 style={{ color: 'red' }}>{msg.errorCerca}</h5>}

            <div ref={divTipoEvento}>
                <p> {numCar.tipo} caratteri<span style={{ fontSize: 'small' }}> (max 2000)</span></p>
                <div style={{ border: '1px solid lightgrey', padding: '3px', width: 'fit-content', margin: '1rem 0 1rem 0' }}>
                    {
                        cercaEventi.map((elem, index) => (
                            <p key={index} style={{ marginBottom: '-4px', borderBottom: '1px solid lightgrey' }}>{elem}</p>
                        ))
                    }
                </div>
                <button className='btn btn-secondary' onClick={cittàCercate}>Città cercate</button>
                <button className='btn btn-primary float-end' onClick={pulisci}>Pulisci</button>
            </div>

            <div ref={divLuogoEvento} style={{ display: 'none' }}>
                <p> {numCar.luogo} caratteri<span style={{ fontSize: 'small' }}> (max 2000)</span></p>
                <div style={{ border: '1px solid lightgrey', padding: '3px', width: 'fit-content', margin: '1rem 0 1rem 0' }}>{
                    cercaCittà.map((elem, index) => (
                        <p key={index} style={{ marginBottom: '-4px', borderBottom: '1px solid lightgrey' }}>{elem}</p>
                    ))
                }
                </div>
                <button className='btn btn-primary mt-3' onClick={() => {
                    divLuogoEvento.current.style.display = "none"
                    divTipoEvento.current.style.display = "block"
                    setTitolo('EVENTI CERCATI DAGLI UTENTI')
                }}>Indietro
                </button>
            </div>
        </div>

    </>)
}
export default CercaEventi